/**
 * Cele trei forme ale acelorasi ferestre - `maintenance/_switch.php`:
 * lista, luna, ziua. Nu o a patra intrare in banda CMDB: banda listeaza
 * subiecte, iar asta nu e un subiect nou.
 */
export function MaintenanceShapes({ active, dayDate, size = 'xs' }: { active: 'list' | 'month' | 'day'; dayDate: string; size?: 'xs' | 'sm' }) {
  const shapes: { key: 'list' | 'month' | 'day'; url: string; icon: string; label: string }[] = [
    { key: 'list', url: '/app/maintenance', icon: 'fa-list', label: 'List' },
    { key: 'month', url: '/app/maintenance/calendar', icon: 'fa-calendar-alt', label: 'Month' },
    { key: 'day', url: `/app/maintenance/day?date=${dayDate}`, icon: 'fa-clock', label: 'Day' },
  ]

  return (
    <span className="adm-shapes">
      {shapes.map((shape) => (
        <a key={shape.key} className={`btn btn-${size} ${active === shape.key ? 'btn-primary' : 'btn-default'}`} href={shape.url}>
          <i className={`fas ${shape.icon}`}></i> {shape.label}
        </a>
      ))}
    </span>
  )
}

/** Iconita dupa ce acopera fereastra - firma, clasa sau un singur element. */
export const SCOPE_ICON: Record<number, string> = { 1: 'fa-building', 2: 'fa-layer-group', 3: 'fa-cube' }
